<template>
  <div class="talent-wrap">
    <div class="talent-body-wrap home-mini-width hom-max-width">
      <TitleCard title="资源检索" :type="'firstCard'" :showMore="false"></TitleCard>
      <div class="search-wrap">
        <InputSearch ref="reff" class="searchItem" placeholder="输入关键字搜索" @search="handleSearch" :keywords="keywords"
          :isBtn="true"></InputSearch>
      </div>
      <div class="TitleCard-all">
        <TitleCard title="全部" :type="'firstCard'" :showMore="false"></TitleCard>
      </div>
      <div class="switch-wrap">
        <div class="resultList" v-if="result.length > 0">
          <div class="result-wrap" v-for="item in result" :key="item.id" @click="toDetails(item.id)">
            <div class="result-title">
              {{ item.title }}
            </div>
            <div class="result-infomation">
              <div>{{ item.type }}</div>
              <div>发布时间：{{ item.publishTime }}</div>
            </div>
          </div>
        </div>
        <Pagination :total="total" @pageChange="change" ref="pagination"></Pagination>
        <div class="general-side-wrap generalInfos-list-wrap" v-if="result2.length > 0">
          <div class="list-item-wrap" v-for="(listIten, index) in result2" :key="index">
            <div class="fText" @click="toDetails(listIten.id)">
              {{ listIten.title }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Pagination from '@/components/common/Pagination';
  import InputSearch from '@/components/InputSearch/index.vue';

  export default {
    data() {
      return {
        result: [{
            title: '一种管理一体化管理系统',
            id: '0',
            time: '2021年4月21日',
            type: "综合信息"
          },
          {
            title: '一种管理一体化管理系统',
            id: '1',
            time: '2021年4月21日',
            type: "综合信息"
          },
          {
            title: '一种管理一体化管理系统',
            id: '2',
            time: '2021年4月21日',
            type: "综合信息"
          },
          {
            title: '一种管理一体化管理系统',
            id: '3',
            time: '2021年4月21日',
            type: "综合信息"
          },
        ],
        total: 100,
        result2: [],
        keywords: ''
      };
    },
    methods: {
      // 分页
      change(e) {
        this.searchParams.pageNum = e;
        this.loadData();
      },
      handleSearch() {

      },
      toDetails() {

      }
    },
    components: {
      Pagination,
      InputSearch
    },
  };
</script>